export const environment = {
    production: true,
    shippingApiUrl: 'https://tyx-webapp-shippingservice.azurewebsites.net',
    accountsApiUrl: 'https://api.transnetyx.com/accounts/v1/registration/user-info',
    
    auth0: {
        domain: 'login.transnetyx.com',
        clientId: 'wiiSjFLebzQScvd0wxnUfaFIA8v5PEAg',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts.transnetyx.com/v2/logout/quick-order`,
        logoutUrl: 'https://login.transnetyx.com/v2/logout',
    },

    colonyUrl: 'https://colony.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder.transnetyx.com',
    geneticMonitoringUrl: 'https://quickorder.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder.transnetyx.com/MVC/Microbiome/home',
    ordersUrl: 'https://quickorder.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts.transnetyx.com/Account/Details',
    quickorderSettingsUrl: 'https://quickorder.transnetyx.com/Account.aspx',
    billingSettingsUrl: 'https://quickorder.transnetyx.com/OrderSearch.aspx',
    messageSettingsUrl: 'https://quickorder.transnetyx.com/EmailPreferences.aspx',
    orderSearchUrl: 'https://quickorder.transnetyx.com/OrderSearch.aspx',
};
